import React from "react";
import { Link } from "react-router-dom";
import type { Product } from "../../hooks/products/types";
import { buildProductUrl } from "../../utils/navigation";

type BannerThreeProps = {
  products?: Product[];
  product?: Product;
};

const BannerThree: React.FC<BannerThreeProps> = ({
  products = [],
  product: singleProduct,
}) => {
  const getProduct = (index: number) => {
    if (products && products.length > index) return products[index];
    if (index === 0 && singleProduct) return singleProduct;
    return undefined;
  };

  const product = getProduct(0);

  return (
    <div className="w-full pt-4 sm:pt-6 md:pt-8 h-full">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="bg-linear-to-r from-primary-600 to-primary-700 rounded-3xl relative overflow-hidden py-8 sm:py-12 md:py-16 h-full flex items-center">
          {product ? (
            <div className="flex flex-col lg:flex-row items-center w-full">
              <div className="lg:w-1/2 px-4 sm:px-8 lg:pl-16 text-center lg:text-left">
                <div className="text-white">
                  <h1 className="font-bold text-2xl sm:text-3xl md:text-4xl mb-4 sm:mb-6 leading-tight">
                    {product.name}
                  </h1>
                  <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 leading-relaxed line-clamp-2">
                    {product.description}
                  </p>
                  <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 justify-center lg:justify-start">
                    <Link
                      to={buildProductUrl(product.id, product.name, product.brand_name)}
                      className="bg-white text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-medium hover:bg-accent hover:text-white border border-white transition-colors text-sm sm:text-base"
                    >
                      Shop Now
                    </Link>
                  </div>
                </div>
              </div>
              <div className="lg:w-1/2 mt-6 sm:mt-8 lg:mt-0 px-4 sm:px-8">
                <div className="text-center lg:text-right">
                  <img
                    src={product.image || ""}
                    alt={product.name}
                    className="max-w-full h-auto rounded-lg mx-auto lg:ml-auto"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="w-full h-full flex items-center justify-center animate-pulse">
              <div className="h-8 bg-white/20 rounded w-1/3"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BannerThree;
